// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationInvestigationStatusEnum } from './FermentationInvestigationStatusEnum';
import { fermentationRootCauseEnum } from './FermentationRootCauseEnum';
import { operatorId } from './Operator';
import { calendarDate } from '../../calendar-date';
import { riskLikelihoodEnum } from './RiskLikelihoodEnum';
import { incidentSeverityEnum } from './IncidentSeverityEnum';
import { z } from 'zod';
export const fermentationInvestigationId = (z.number());
export const fermentationInvestigation = z.object({
    id: fermentationInvestigationId,
    title: z.string(),
    status: fermentationInvestigationStatusEnum,
    root_cause_category: fermentationRootCauseEnum.nullable(),
    root_cause_analysis: z.string().nullable(),
    corrective_action: z.string().nullable(),
    corrective_responsible_operator_id: operatorId.nullable(),
    corrective_completed_on: calendarDate.nullable(),
    corrective_verification: z.string().nullable(),
    preventive_action: z.string().nullable(),
    preventive_responsible_operator_id: operatorId.nullable(),
    preventive_due_on: calendarDate.nullable(),
    preventive_effectiveness_check: z.string().nullable(),
    reviewed_by: operatorId.nullable(),
    reviewed_on: calendarDate.nullable(),
    residual_likelihood: riskLikelihoodEnum.nullable(),
    residual_severity: incidentSeverityEnum.nullable(),
    closed_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const fermentationInvestigationInitializer = z.object({
    id: fermentationInvestigationId.optional(),
    title: z.string(),
    status: fermentationInvestigationStatusEnum.optional(),
    root_cause_category: fermentationRootCauseEnum.optional().nullable(),
    root_cause_analysis: z.string().optional().nullable(),
    corrective_action: z.string().optional().nullable(),
    corrective_responsible_operator_id: operatorId.optional().nullable(),
    corrective_completed_on: calendarDate.optional().nullable(),
    corrective_verification: z.string().optional().nullable(),
    preventive_action: z.string().optional().nullable(),
    preventive_responsible_operator_id: operatorId.optional().nullable(),
    preventive_due_on: calendarDate.optional().nullable(),
    preventive_effectiveness_check: z.string().optional().nullable(),
    reviewed_by: operatorId.optional().nullable(),
    reviewed_on: calendarDate.optional().nullable(),
    residual_likelihood: riskLikelihoodEnum.optional().nullable(),
    residual_severity: incidentSeverityEnum.optional().nullable(),
    closed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const fermentationInvestigationMutator = z.object({
    id: fermentationInvestigationId.optional(),
    title: z.string().optional(),
    status: fermentationInvestigationStatusEnum.optional(),
    root_cause_category: fermentationRootCauseEnum.optional().nullable(),
    root_cause_analysis: z.string().optional().nullable(),
    corrective_action: z.string().optional().nullable(),
    corrective_responsible_operator_id: operatorId.optional().nullable(),
    corrective_completed_on: calendarDate.optional().nullable(),
    corrective_verification: z.string().optional().nullable(),
    preventive_action: z.string().optional().nullable(),
    preventive_responsible_operator_id: operatorId.optional().nullable(),
    preventive_due_on: calendarDate.optional().nullable(),
    preventive_effectiveness_check: z.string().optional().nullable(),
    reviewed_by: operatorId.optional().nullable(),
    reviewed_on: calendarDate.optional().nullable(),
    residual_likelihood: riskLikelihoodEnum.optional().nullable(),
    residual_severity: incidentSeverityEnum.optional().nullable(),
    closed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationInvestigation.js.map